import isNumber from 'lodash/isNumber';
import isFunction from 'lodash/isFunction';
import moment from 'moment';
/**
 * @param {ErrorResponse} errorResponse
 * @param {?(string|function)} tooManyRequestMessage
 *
 * @returns {?string}
 */

export default (function (errorResponse, tooManyRequestMessage) {
  var _ref = errorResponse.getData() || {},
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? null : _ref$error,
      _ref$error_properties = _ref.error_properties,
      errorProperties = _ref$error_properties === void 0 ? {
    wait_for: null
  } : _ref$error_properties;

  if (errorResponse.getStatus() !== 429 && error !== 'rate_limit_exceeded') {
    return null;
  }

  if (!isFunction(tooManyRequestMessage)) {
    return tooManyRequestMessage;
  }

  var waitFor = null;

  if (error === 'rate_limit_exceeded') {
    waitFor = isNumber(errorProperties.wait_for) ? errorProperties.wait_for : null;
  } else {
    var headers = errorResponse.headers;
    waitFor = isNumber(headers['gf-wait-for']) ? headers['gf-wait-for'] : null;
  }

  if (waitFor !== null) {
    waitFor = moment.duration(parseInt(waitFor, 10), 'seconds');
  }

  return tooManyRequestMessage(errorResponse, waitFor);
});